import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { DataManipulationService } from '../services/data-manipulation.service';
import { ApiwrapperService } from '../services/apiwrapper.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddonGuard implements CanActivate {
  constructor(private data: DataManipulationService, private api: ApiwrapperService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const requiredAddon = route.data['requiredAddon'];

    return this.api.getWorkspaceAddons().pipe(
      map((res) => {
        const addons = res?._embedded?.addons ?? [];
        const hasAddon = addons.some((addon: any) => addon.addOn.slug === requiredAddon);
        return hasAddon ? true : this.router.parseUrl('/');
      })
    )
  }
}
